module.exports = __webpack_public_path__ + "img/Calos-Gonzalez-Fillad.863b2322.png";